<script>
import { mapGetters, mapActions } from 'vuex';
import * as actions from '../../../../vuexStore/actions.js';
import * as namespaceStore from '../../../../vuexStore/namespaceStore.js'
export default {
    name: 'BasePreviewComponents',
    props: {
        el: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(namespaceStore.THEME, [
            'currentElementIndex',
        ]),
        showOnlyOnSelect: function() {
            return (this.el.showOnlyOnSelect == true && this.currentElementIndex == this.el.previewId) || this.el.showOnlyOnSelect == false;
        }
    },
    methods: {
        ...mapActions(namespaceStore.THEME, {
            'startDrag': actions.START_DRAG,
            'startResize': actions.START_RESIZE,
            'setSelectedElement': actions.SET_SELECTED_ELEMENT
        }),
        styleDynamicElement: function (el) {
            let style = el.getStyleOnlyPosition();
            if (el.objectType == "DynamicElement") {
                style.backgroundColor = "white";
            }
            return style;
        },
        eventResize(event, elementIndex, direction) {
            if (elementIndex && this.startDrag) {
                this.startResize({ev: event, el: elementIndex, direction: direction});
                event.stopPropagation();
            }
        },
        eventDrag(event, elementIndex) {
            if (elementIndex && this.startDrag) {
                this.startDrag({ev: event, el: elementIndex});
                event.stopPropagation();
            } else {
                console.error('startDrag function or element is not available:', { startDrag: this.startDrag, element: elementIndex })
            }
        },
    }
}
</script>

<style>
.trigger-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    animation-direction: alternate;
}

.trigger-container.dragged,
.trigger-container.dragged .trigger-left,
.trigger-container.dragged .trigger-right,
.trigger-container.dragged .trigger-top,
.trigger-container.dragged .trigger-bottom,
.trigger-container.dragged .trigger-top-left,
.trigger-container.dragged .trigger-top-right,
.trigger-container.dragged .trigger-bottom-left,
.trigger-container.dragged .trigger-bottom-right {
    z-index: 10;
}

.trigger-container.selected,
.trigger-container.selected .trigger-left,
.trigger-container.selected .trigger-right,
.trigger-container.selected .trigger-top,
.trigger-container.selected .trigger-bottom,
.trigger-container.selected .trigger-top-left,
.trigger-container.selected .trigger-top-right,
.trigger-container.selected .trigger-bottom-left,
.trigger-container.selected .trigger-bottom-right {
    z-index: 500 !important;
    opacity: 0.85;
}

.trigger-container:hover::after {
    content: "";
    position: absolute;
    pointer-events: none;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(0, 0, 0, 0.8);
}

.trigger-left {
    position: absolute;
    top: 30px;
    left: -30px;
    bottom: 30px;
    width: 60px;
    cursor: w-resize;
    z-index: 1;
}
.trigger-right {
    position: absolute;
    top: 30px;
    right: -30px;
    bottom: 30px;
    width: 60px;
    cursor: e-resize;
    z-index: 1;
}
.trigger-top {
    position: absolute;
    top: -30px;
    left: 30px;
    right: 30px;
    height: 60px;
    cursor: n-resize;
    z-index: 1;
}
.trigger-bottom {
    position: absolute;
    bottom: -30px;
    left: 30px;
    right: 30px;
    height: 60px;
    cursor: s-resize;
    z-index: 1;
}
.trigger-top-left {
    position: absolute;
    top: -30px;
    left: -30px;
    width: 60px;
    height: 60px;
    cursor: nw-resize;
    z-index: 1;
}
.trigger-top-right {
    position: absolute;
    top: -30px;
    right: -30px;
    width: 60px;
    height: 60px;
    cursor: ne-resize;
    z-index: 1;
}
.trigger-bottom-left {
    position: absolute;
    bottom: -30px;
    left: -30px;
    width: 60px;
    height: 60px;
    cursor: sw-resize;
    z-index: 1;
}
.trigger-bottom-right {
    position: absolute;
    bottom: -30px;
    right: -30px;
    width: 60px;
    height: 60px;
    cursor: se-resize;
    z-index: 1;
}

</style>

